import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initOtherNewsSlider() {
    const otherNewsSwiper = new Swiper(".other-news-slider", {
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: ".more-news-slider-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".more-news-slider-next",
            prevEl: ".more-news-slider-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 18,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });
    window.addEventListener('resize', checkOtherNewsNavigationWrapperStatus);
    // Call the function initially
    checkOtherNewsNavigationWrapperStatus();
    return otherNewsSwiper
}

function checkOtherNewsNavigationWrapperStatus(){
    const otherNewsNavigationWrapper = document.querySelector(".more-news__slider-action");
    const otherNewsSliderNext = document.querySelector(".more-news-slider-next");
    // Check if the element has the class "swiper-button-lock"
    if (otherNewsSliderNext.classList.contains("swiper-button-lock")) {
        otherNewsNavigationWrapper.classList.add('d-none');
    } else {
        otherNewsNavigationWrapper.classList.remove('d-none');
    }
}

